import { WINDOWS_CDN_PATH } from '../../../windows-constants';

export const DECEUNINCK_BRAND_STRUCTURE = {
  title: 'brands-section.deceuninck-title',
  description: 'brands-section.deceuninck-description',
  detailedInfo: [
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/forward.jpg/forward.jpg`,
      name: 'Forward',
      mountingWidth: '60 мм',
      numberOfCameras: '3',
      thermalInsulation: '0,65 м² ̊С/Вт',
      doubleGlazing: 'до 38 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/favorit-platinum.jpg/favorit-platinum.jpg`,
      name: 'Favorit Platinum',
      mountingWidth: '71 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,77 м² ̊С/Вт',
      doubleGlazing: 'до 47 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/bautec-urban.jpg/bautec-urban.jpg`,
      name: 'Bautec Urban',
      mountingWidth: '71 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,81 м² ̊С/Вт',
      doubleGlazing: 'до 40 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/favorit-space.jpg/favorit-space.jpg`,
      name: 'Favorit Space',
      mountingWidth: '76 мм',
      numberOfCameras: '6',
      thermalInsulation: '0,87 м² ̊С/Вт',
      doubleGlazing: 'до 48 мм',
    },
  ],
};
